<template>
  <!-- delete files / folders dialog -->
  <qc-dialog class="tc-15-rich-dialog cos" :show="innerShow" type="custom" :title="$t('core.delete')"
    :default-cancel="false" :width="450" @close="closeDialog">
    <ul class="item-descr-list">
      <li>
        <div class="tc-panel">
          <div class="tc-panel-hd mb-0">
            <div class="col">
              <h3 class="title">{{$t('cos.confirm.delete_files_or_folders')}}</h3>
            </div>
          </div>
          <div class="tc-panel-bd">
            <qc-table-client-pagination :list="selectedList" min-height="30px" max-height="250px" :page-size="1000">
              <qc-table-column :label="$t('core.file_or_folder')" field="name">
                <template slot-scope="{ item }">
                  <div>{{item.isDir? `${item.name}/`: item.name}}</div>
                </template>
              </qc-table-column>
              <qc-table-column :label="$t('core.size')">
                <template slot-scope="{ item }">
                  <div>{{item.sizeText || '-'}}</div>
                </template>
              </qc-table-column>

              <template slot="pagination" slot-scope="page">
                <qc-pagination v-if="page.totalNum > 1000" :total-num="page.totalNum" :page-size.sync="page.pageSize"
                  :curr-page.sync="page.currPage" :min-page-size="1000" :max-page-size="1000" :page-size-step="1000">
                </qc-pagination>
                <!-- 为了避免插槽 fallback 回默认分页器，以下一行代码不可删除 -->
                <span style="display: none;"></span>
              </template>
            </qc-table-client-pagination>
          </div>
        </div>
      </li>
    </ul>

    <div slot="button">
      <div class="justify-grid">
        <div class="col"></div>
        <div class="col">
          <qc-button type="default" @click="deleteFiles" :title="$t('core.ok')">{{$t('core.ok')}}
          </qc-button>
          <qc-button type="weak" @click="closeDialog" :title="$t('core.close')">{{$t('core.close')}}
          </qc-button>
        </div>
      </div>
    </div>

  </qc-dialog>
</template>

<script>
import fileDeleter from 'helper/fileDeleter';

import { tips, getInnerProps, removeFromList } from 'tools/utils';

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
      default: false,
    },
    list: {
      type: Array,
      required: true,
    },
    selectedList: {
      type: Array,
      required: true,
    },
    bucketInfo: Object,
  },
  computed: {
    innerShow: getInnerProps('show'),
    innerList: getInnerProps('list'),
  },
  methods: {
    deleteFiles() {
      tips.loading(this.$t('core.deleting'));
      const { Bucket, Region } = this.bucketInfo;
      const list = this.selectedList;
      this.closeDialog();

      fileDeleter(
        {
          Bucket,
          Region,
          List: list,
        },
        (err, data) => {
          const count = data.globalSuccessCount;
          tips.loading(this.$t('core.deleting_files', { count }));
        },
        (err, data) => {
          if (data) {
            const { successList, totalList } = data;
            // 若删除完全成功，则直接移除列表中的对象
            if (successList.length === totalList.length) {
              this.updateList([...list, ...successList]);
              this.$emit('fix-folder');
            } else {
              this.$emit('fix-folder');
              this.$emit('refresh');
            }
          }
        },
      );
    },
    updateList(removeList) {
      const { list } = this;
      this.innerList = removeFromList(removeList, list);
      this.$emit('arrange-list'); // 整理桌面排序
    },
    closeDialog() {
      this.innerShow = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$xs: 360px;
$sm: 600px;
$md: 768px;
.tc-15-rich-dialog {
  ::v-deep .dialog__container {
    @media screen and (max-width: $sm) {
      .tc-15-rich-dialog {
        width: 100% !important;
      }
    }
  }
}
</style>
